import React from "react";
import { useSelector } from "react-redux";

const TheHeader = () => {
  const { corpNm } = useSelector((state) => state.main);
  const { corpBnrImg } = useSelector((state) => state.main);
  const appUrl = `${process.env.REACT_APP_API_HOST}`;
  
  return (
    <>
      <header className="mainHeader">
        <div className="logo">
          <img src={corpNm === 'agp' ? '/easypaper_BI.png' : appUrl+'ezp/corp/getImages/logo?'+corpBnrImg} alt="logo" width="150px" />
        </div>
      </header>
    </>
  );
};

export default TheHeader;
